import React, { useEffect, useRef, useState } from 'react';

function Contato() {
  const imageRef = useRef(null);
  const [isImageVisible, setIsImageVisible] = useState(false);

  useEffect(() => {
    const imageElement = imageRef.current;

    if (!imageElement) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsImageVisible(entry.isIntersecting);
      },
      {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.25,
      },
    );

    observer.observe(imageElement);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="position-relative overflow-hidden p-1 p-md-5 m-md-3 text-center bg-light row align-items-center">
      <div className="col-md-5 p-lg-5 mx-auto my-3">
        <h2 className="m-3">Contato</h2>
        <p className="m-5 justificar-texto">Te surgiram dúvidas ou interesse sobre o meu trabalho? Escolha a melhor maneira de me contatar: WhatsApp, e-mail ou Instagram, clicando nos ícones abaixo, e estarei te respondendo o mais breve possível.</p>
      </div>
      <div className="col-md-5 p-lg-5  mx-auto my-3">
        <img
          ref={imageRef}
          src="logo-mano.png"
          className={`img-fluid rounded-circle quem-image quem-image-pulse ${isImageVisible ? 'is-visible' : ''}`}
          alt="Logotipo de Manô Medeiros"
        />
      </div>
    </div>
  );
}

export default Contato;